import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class AssignSTOItemPageStyle extends CommonComponentStyle {
  SubtitleWrapper = styled(Grid)`
    padding: 8px 0 16px 0;
  `;

  Subtitle = styled(Grid)`
    font-size: 14px;
    font-weight: 700;
  `;

  SelectItems = styled('button')`
    border: none;
    color: #1733e8;
    font-size: 14px;
    background-color: transparent;
  `;

  GridWrapper = styled(Grid)`
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  `;

  SkuNumberGridWrapper = styled(Grid)`
    background: ${this.colors.LIGHTER_GRAY};
    padding: 8px;
  `;

  SkuInfoGrid = styled(Grid)`
    font-size: 14px;
    font-weight: 700;

    display: inline-block;
    vertical-align: middle;

    &.sto-number {
      text-align: right;
    }
  `;

  STONumberInfoGrid = styled(Grid)(({ theme }) => ({
    background: this.colors.LIGHT_GRAY,
    color: this.colors.PRIMARY_GRAY,
    maxWidth: 'fit-content',
    padding: '8px 12px',
    borderRadius: '8px',
    fontSize: '10px',
    marginTop: '8px',

    [theme.breakpoints.down('sm')]: {
      float: 'right',
    },
  }));

  AdditionalInfoGrid = styled('p')`
    font-size: 12px;
  `;

  ButtonGrid = styled(Grid)`
    text-align: right;
  `;

  AddSTOItemButtonWrapper = styled('div')`
    text-align: center;
    width: 100%;
    margin-top: 8px;
  `;

  CancelAssignmentButton = styled(this.SecondaryButton)`
    width: 200px !important;
    margin-bottom: 16px;
  `;
}

export default new AssignSTOItemPageStyle();
